export const styles = {
  form: {
    display: "grid",
    gridGap: 35,
  },
};
